import {Avatar, Tooltip} from "../../__snowpack__/pkg/antd.js";
import React from "../../__snowpack__/pkg/react.js";
import {platformLogo} from "../lib/basic.js";
export const TableStore = (props) => {
  const {channelName, shopName} = props;
  console.log("channelName", channelName);
  return /* @__PURE__ */ React.createElement("span", {
    style: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center"
    }
  }, /* @__PURE__ */ React.createElement(Avatar, {
    size: props.size ? props.size : 32,
    src: platformLogo(channelName, true),
    style: {
      marginRight: props.size ? 5 : 10,
      width: props.size || 32,
      minWidth: props.size || 32,
      maxWidth: props.size || 32
    }
  }), /* @__PURE__ */ React.createElement(Tooltip, {
    title: shopName || "-"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "sign-one",
    style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, props.countryCode && /* @__PURE__ */ React.createElement(React.Fragment, null, "(", props.countryCode, ") "), shopName || "-")));
};
